import userInfo from 'hub-http/userInfo';
import { useEffect, useState } from 'react';
export const useUserInfo = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    userInfo().then(u => setUser(u)).catch(e => {
      console.error('Error fetching user info', e);
      setError(e);
    }).finally(() => setLoading(false));
  }, []);
  return {
    user,
    loading,
    error
  };
};